import { memo } from "react";

import ThreadSidebar from "@/features/knowledge-graph/components/organisms/ThreadSidebar";
import ChatScreen from "../Chat";

import { Box } from "@/components/atoms/Box";
import { Pressable } from "@/components/atoms/Pressable";

/**
 * Props for the MainView component
 */
interface MainViewProps {
  isSidebarVisible: boolean;
  isDesktop: boolean;
  onCloseSidebar: () => void;
}

/**
 * Main view component for the knowledge graph chat interface with thread sidebar
 * @param root0 - Component props
 * @param root0.isSidebarVisible - Whether the thread sidebar is currently visible
 * @param root0.isDesktop - Whether the screen width is desktop size (>= 1280px)
 * @param root0.onCloseSidebar - Callback to close the thread sidebar
 */
const MainView = ({
  isSidebarVisible,
  isDesktop,
  onCloseSidebar,
}: MainViewProps) => (
  <Box className="relative flex h-full flex-1 flex-row">
    {/* Thread Sidebar - inline on desktop, absolute overlay on mobile */}
    <ThreadSidebar
      isVisible={isSidebarVisible}
      onClose={onCloseSidebar}
      isDesktop={isDesktop}
    />

    {/* Backdrop - only visible on mobile when sidebar is open */}
    {isSidebarVisible && !isDesktop && (
      <Pressable
        accessibilityLabel="Close sidebar"
        onPress={onCloseSidebar}
        className="absolute inset-0 z-30 bg-black/50"
        pointerEvents="auto"
      />
    )}

    {/* Main Content Area */}
    <Box
      className="z-0 flex-1"
      // @ts-expect-error - pointerEvents is valid but not in Box types
      pointerEvents={isSidebarVisible && !isDesktop ? "none" : "auto"}
    >
      <ChatScreen />
    </Box>
  </Box>
);

MainView.displayName = "MainView";

export default memo(MainView);
